import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

const Page = {
  handleTabs: function () {
    const buttons = document.querySelectorAll('[data-tabs-button]');
    const texts = document.querySelectorAll('[data-tabs-text]');
    const hash = window.location.hash;

    if (buttons.length > 0 && texts.length > 0) {
      buttons.forEach((button, i) => {
        button.addEventListener('click', () => {
          buttons.forEach((b) => {
            b.classList.remove('-active');
          });
          texts.forEach((t) => {
            t.classList.remove('-active');
          });

          buttons[i].classList.add('-active');
          texts[i].classList.add('-active');
        });
        if (hash && hash == button.getAttribute('data-tabs-button')) button.click();

        window.addEventListener('hashchange', () => {
          const actualHash = window.location.hash;
          const actualTab = document.querySelector(`[data-tabs-button="${actualHash}"]`);
          if(actualTab) actualTab.click();

          actualTab.addEventListener('click', () => {
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
          });
        });
      });
    }
  },

  handleProjectGallery: function () {
    window.ProjectGallery = {
      swiper: null,

      open(images, startIndex = 0) {
        const lightbox = document.getElementById('projects-lightbox');
        const wrapper = lightbox.querySelector('.swiper-wrapper');

        wrapper.innerHTML = '';

        images.forEach((url) => {
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide');
          slide.innerHTML = `
            <img src="${url}" />
          `;
          wrapper.appendChild(slide);
        });

        if (this.swiper) this.swiper.destroy(true, true);

        this.swiper = new Swiper('[data-projects-lightbox-swiper]', {
          slidesPerView: 1,
          preloadImages: false,
          lazy: { loadOnTransitionStart: true },
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
        });

        this.swiper.slideTo(startIndex, 0);
        this.swiper.update();

        lightbox.classList.add('open');
        document.body.classList.add('no-scroll');
      },

      close() {
        document.getElementById('projects-lightbox').classList.remove('open');
        document.body.classList.remove('no-scroll');
      },
    };
  },

  bindProjectGalleryClicks: function () {
    document.addEventListener('click', (ev) => {
      const imgEl = ev.target.closest('.project .image img');

      if (imgEl) {
        const projectEl = imgEl.closest('.project');

        const allImgs = [...projectEl.querySelectorAll('.image img')].map(
          (i) => i.dataset.original || i.src
        );

        const index = [...projectEl.querySelectorAll('.image img')].indexOf(imgEl);

        window.ProjectGallery.open(allImgs, index);
      }

      if (
        ev.target.closest('.projects-lightbox__close') ||
        ev.target.classList.contains('projects-lightbox__backdrop')
      ) {
        window.ProjectGallery.close();
      }
    });
  },

  // ===============================

  init: function () {
    let page = window.location.href;

    if (page.includes('termos')) this.handleTabs();

    // inicia galeria em qualquer página onde exista um projeto
    if (document.querySelector('.section-projects')) {
      this.handleProjectGallery();
      this.bindProjectGalleryClicks();
    }
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init();
});
